import { render, staticRenderFns } from "./SubtableList.vue?vue&type=template&id=ef23b87e&scoped=true&"
import script from "./SubtableList.vue?vue&type=script&lang=js&"
export * from "./SubtableList.vue?vue&type=script&lang=js&"
import style0 from "./SubtableList.vue?vue&type=style&index=0&id=ef23b87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef23b87e",
  null
  
)

export default component.exports